import { Component, Injector, Input, forwardRef, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { InputClass } from '@app/core/classes/input';

const INPUT_CONTROL_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AmnInputCheckboxComponent),
  multi: true
};

@Component({
  selector: 'app-amn-input-checkbox',
  templateUrl: './amn-input-checkbox.component.html',
  styleUrls: ['./amn-input-checkbox.component.scss'],
  providers: [INPUT_CONTROL_ACCESSOR]
})
export class AmnInputCheckboxComponent extends InputClass implements OnInit {
  @Input() id: string = '';
  @Input() label: string = '';
  @Input() errorMessages: { [key: string]: string } = {};

  public ngControl!: NgControl;
  public isDisabled: boolean = false;

  constructor(private injector: Injector) {
    super();
  }

  ngOnInit() {
    Promise.resolve().then(() => {
      this.ngControl = this.injector.get(NgControl);
      if (this.ngControl && this.ngControl.valueAccessor) {
        this.ngControl.valueAccessor = this;
      }
    });
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  hasError(errorCode: string): boolean | null {
    return (
      this.ngControl.enabled &&
      this.ngControl.hasError(errorCode) &&
      this.ngControl.dirty
    );
  }

  onValueChanged() {
    this.updateValue(this.value);
  }
}
